import { useCallback } from 'react';
import EngagementHistoryV2Async from './EngagementHistoryV2Async';
import TimelineErrorBoundary from '../error/TimelineErrorBoundary';
import EngagementHistoryError from './EngagementHistoryError';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { H2 } from 'foundations-components/transitional/components/H2';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { EngagementHistoryStore, clearEngagementHistory, isEmpty } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH = 750;
export const engagementHistoryDep = {
  stores: [EngagementHistoryStore],
  deref() {
    return EngagementHistoryStore.get();
  }
};
const EngagementHistoryWrapper = () => {
  const currentEngagementHistory = useStoreDependency(engagementHistoryDep);
  const handleTracking = useCallback((action, {
    pageNumber,
    search
  } = {}) => {
    const engagementOrInteractionType = currentEngagementHistory.get('engagementOrInteractionType', '');
    const objectId = currentEngagementHistory.get('objectId');
    const objectType = currentEngagementHistory.get('objectType');
    CrmLogger.log('timelineInteractions', {
      action,
      activity: engagementOrInteractionType.toLowerCase(),
      activityId: objectId,
      object: objectType,
      pageNumber,
      search
    });
  }, [currentEngagementHistory]);
  const handleToggleEngagementHistory = useCallback(() => {
    handleTracking('Closing engagement history');
    clearEngagementHistory();
  }, [handleTracking]);
  if (isEmpty(currentEngagementHistory)) {
    return null;
  }
  const engagementOrInteractionType = currentEngagementHistory.get('engagementOrInteractionType');
  const objectId = currentEngagementHistory.get('objectId');
  return /*#__PURE__*/_jsxs(Panel, {
    width: PANEL_WIDTH,
    children: [/*#__PURE__*/_jsxs(PanelHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleToggleEngagementHistory,
        "data-selenium-test": "engagement-history-close-button"
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "components.engagementHistory.label"
        })
      })]
    }), /*#__PURE__*/_jsx(TimelineErrorBoundary, {
      ErrorComponent: EngagementHistoryError,
      boundaryName: "GraphQLEngagementHistory_Error",
      children: /*#__PURE__*/_jsx(PanelBody, {
        children: /*#__PURE__*/_jsx(PanelSection, {
          children: /*#__PURE__*/_jsx(EngagementHistoryV2Async, {
            engagementOrInteractionType: engagementOrInteractionType,
            objectId: objectId
          })
        })
      })
    })]
  });
};
export default EngagementHistoryWrapper;